import { OpportunityManagementView, useOpportunityManagement } from "@/opportunity/OpportunityManagementContext";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import React from "react";

export const OpportunityManagementViewSelector = () => {
  const { view, setView } = useOpportunityManagement();
  return (
    <Tabs
      value={view}
      onValueChange={setView}
    >
      <TabsList>
        <TabsTrigger value={OpportunityManagementView.TABLE} title="Table">
          Table
        </TabsTrigger>
        <TabsTrigger value={OpportunityManagementView.BOARD} title="Board">
          Board
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};